import { useParams } from 'next/navigation'

type Params = ReturnType<typeof useParams>

export const isPublicInvoicePage = (pathname: string, params: Params) => {
  const sections = pathname.split('/')

  return (
    sections[1] === 'invoices' &&
    sections.length === 4 &&
    sections[2] !== 'create' &&
    params &&
    'invoiceId' in params
  )
}
